module.exports = __webpack_public_path__ + "static/media/Productos.2c95d34b.svg";